const cyrillicToLatinMap: Record<string, string> = {
    А: 'A',
    Б: 'B',
    В: 'V',
    Г: 'H',
    Д: 'D',
    Е: 'E',
    Є: 'Ye',
    Ж: 'Zh',
    З: 'Z',
    И: 'Y',
    І: 'I',
    Ї: 'Yi',
    Й: 'Y',
    К: 'K',
    Л: 'L',
    М: 'M',
    Н: 'N',
    О: 'O',
    П: 'P',
    Р: 'R',
    С: 'S',
    Т: 'T',
    У: 'U',
    Ф: 'F',
    Х: 'Kh',
    Ц: 'Ts',
    Ч: 'Ch',
    Ш: 'Sh',
    Щ: 'Shch',
    Ю: 'Yu',
    Я: 'Ya',
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'h',
    д: 'd',
    е: 'e',
    є: 'ye',
    ж: 'zh',
    з: 'z',
    и: 'y',
    і: 'i',
    ї: 'yi',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'kh',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ю: 'yu',
    я: 'ya',
    ь: '',
};
const cyrillicToLatinMapNumberPlate: Record<string, string> = {
    А: 'A',
    В: 'B',
    Е: 'E',
    Є: 'E',
    И: 'N',
    І: 'I',
    Й: 'Y',
    К: 'K',
    Л: 'L',
    М: 'M',
    Н: 'H',
    О: 'O',
    Р: 'P',
    С: 'C',
    Т: 'T',
    У: 'Y',
    Ф: 'F',
    Х: 'X',
};

const solidLetters = [
    'Б',
    'В',
    'Г',
    'Д',
    'Ж',
    'З',
    'К',
    'Л',
    'М',
    'Н',
    'П',
    'Р',
    'С',
    'Т',
    'Ф',
    'Х',
    'Ц',
    'Ч',
    'Ш',
    'Щ',
    'б',
    'в',
    'г',
    'д',
    'ж',
    'з',
    'к',
    'л',
    'м',
    'н',
    'п',
    'р',
    'с',
    'т',
    'ф',
    'х',
    'ц',
    'ч',
    'ш',
    'щ',
];
const twoSoundVowelLetters = ['я', 'є', 'ю', 'ї'];
const solidFollowMap: Record<string, string> = {
    я: 'ia',
    є: 'ie',
    ю: 'iu',
    ї: 'ii',
};
const vowelFollowMap: Record<string, string> = {
    я: 'ya',
    є: 'ye',
    ю: 'yu',
    ї: 'yi',
};

export function transliterate(text: string, type?: "default" | "numberPlate"): string {
    let result = '';
    let prevChar = '';

    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (twoSoundVowelLetters.includes(char)) {
            if (solidLetters.includes(prevChar)) {
                result += solidFollowMap[char];
            } else {
                result += vowelFollowMap[char];
            }
        } else {
          const sourceMap = type === "numberPlate" ? cyrillicToLatinMapNumberPlate : cyrillicToLatinMap;
            result +=
                typeof sourceMap[char] === 'string'
                    ? sourceMap[char]
                    : char;
        }
        prevChar = char;
    }

    return result;
}
